import { WaterpoloGameLogTypes } from '../models/waterpolo-game-log';
import { Locales } from './locales';

export const WaterpoloGameLogTypeLocalization = {
  [Locales.ru]: {
    [WaterpoloGameLogTypes.enter_game]: 'Выход на площадку',
    [WaterpoloGameLogTypes.exit_game]: 'Ушел с площадки',
    [WaterpoloGameLogTypes.shot_miss]: 'Бросок мимо',
    [WaterpoloGameLogTypes.counterattack_miss]: 'Бросок мимо в контратаке',
    [WaterpoloGameLogTypes.maneuver_miss]: 'Бросок мимо с маневра',
    [WaterpoloGameLogTypes.center_forward_miss]: 'Бросок мимо со столба',
    [WaterpoloGameLogTypes.shot_on_goal]: 'Бросок по воротам',
    [WaterpoloGameLogTypes.counterattack_on_goal]: 'Бросок по воротам в контратаке',
    [WaterpoloGameLogTypes.maneuver_on_goal]: 'Бросок по воротам с маневра',
    [WaterpoloGameLogTypes.center_forward_on_goal]: 'Бросок по воротам со столба',
    [WaterpoloGameLogTypes.shot_blocked]: 'Заблокирован бросок',
    [WaterpoloGameLogTypes.counter_attack_shot_blocked]: 'Заблокирован бросок в контратаке',
    [WaterpoloGameLogTypes.maneuver_shot_blocked]: 'Заблокирован бросок с маневра',
    [WaterpoloGameLogTypes.center_forward_shot_blocked]: 'Заблокирован бросок со столба',
    [WaterpoloGameLogTypes.goal]: 'Гол',
    [WaterpoloGameLogTypes.maneuver_goal]: 'Гол с маневра',
    [WaterpoloGameLogTypes.counterattack_goal]: 'Гол в контратаке',
    [WaterpoloGameLogTypes.center_forward_goal]: 'Гол со столба',
    [WaterpoloGameLogTypes.shootout_attempt]: 'Пенальти промах',
    [WaterpoloGameLogTypes.shootout_goal]: 'Пенальти гол',
    [WaterpoloGameLogTypes.after_game_shootout_attempt]: 'Пенальти промах',
    [WaterpoloGameLogTypes.after_game_shootout_goal]: 'Пенальти гол',
    [WaterpoloGameLogTypes.assist]: 'Голевая передача',
    [WaterpoloGameLogTypes.block_shot]: 'Блокировка броска',
    [WaterpoloGameLogTypes.minor_penalty]: 'Удаление на 20 сек.',
    [WaterpoloGameLogTypes.major_penalty]: 'Удаление + 20 сек. штраф',
    [WaterpoloGameLogTypes.match_penalty]: 'Удаление + 4 мин. штраф',
    [WaterpoloGameLogTypes.foul]: 'Фол',
    [WaterpoloGameLogTypes.penalty_foul]: 'Фол пенальти',
    [WaterpoloGameLogTypes.attack_foul]: 'Фол в нападении',
    [WaterpoloGameLogTypes.personal_foul]: 'Персональный фол',
    [WaterpoloGameLogTypes.penalty_shot]: 'Штрафной бросок',
    [WaterpoloGameLogTypes.face_off_lose]: 'Проигрыш в спринте',
    [WaterpoloGameLogTypes.face_off_win]: 'Победа в спринте',
    [WaterpoloGameLogTypes.save]: 'Отражен бросок',
    [WaterpoloGameLogTypes.counterattack_save]: 'Отражен бросок в контратаке',
    [WaterpoloGameLogTypes.maneuver_save]: 'Отражен бросок с маневра',
    [WaterpoloGameLogTypes.center_forward_save]: 'Отражен бросок со столба',
    [WaterpoloGameLogTypes.free_kick_save]: 'Отражен бросок со свободного',
    [WaterpoloGameLogTypes.corner_save]: 'Отражен бросок с углового',
    [WaterpoloGameLogTypes.shootout_save]: 'Отражен бросок с пенальти',
    [WaterpoloGameLogTypes.after_game_shootout_save]: 'Отражен бросок с пенальти',
    [WaterpoloGameLogTypes.timeout]: 'Таймаут',
    [WaterpoloGameLogTypes.penalty_start]: 'Начало штрафного времени',
    [WaterpoloGameLogTypes.penalty_end]: 'Конец штрафного времени',
    [WaterpoloGameLogTypes.yellow_card]: 'Желтая карточка',
    [WaterpoloGameLogTypes.red_card]: 'Красная карточка',
    [WaterpoloGameLogTypes.turnover]: 'Переход владения',
    [WaterpoloGameLogTypes.loss]: 'Потеря',
    [WaterpoloGameLogTypes.steal]: 'Перехват',
    [WaterpoloGameLogTypes.tackle]: 'Отбор',
    [WaterpoloGameLogTypes.free_kick_goal]: 'Гол со свободного удара',
    [WaterpoloGameLogTypes.free_kick_on_goal]: 'Бросок со свободного удара в створ',
    [WaterpoloGameLogTypes.free_kick_miss]: 'Бросок мимо со свободного удара',
    [WaterpoloGameLogTypes.free_kick_shot_blocked]: 'Заблокирован бросок со свободного удара',
    [WaterpoloGameLogTypes.free_kick_pass]: 'Пас со свободного удара',
    [WaterpoloGameLogTypes.free_kick_self]: 'Розыгрыш свободного удара',
    [WaterpoloGameLogTypes.corner_goal]: 'Гол с углового',
    [WaterpoloGameLogTypes.corner_on_goal]: 'Бросок с углового в створ',
    [WaterpoloGameLogTypes.corner_miss]: 'Бросок мимо с углового',
    [WaterpoloGameLogTypes.corner_shot_blocked]: 'Заблокирован бросок с углового',
    [WaterpoloGameLogTypes.corner_pass]: 'Пас с углового',
    [WaterpoloGameLogTypes.corner_self]: 'Розыгрыш углового',
    [WaterpoloGameLogTypes.complete_penalty_time]: 'Досрочное завершение штрафа',

    [WaterpoloGameLogTypes.defense_select_position]: 'Защита: выбор позиции',
    [WaterpoloGameLogTypes.save_possession]: 'Сохранение владения',
    [WaterpoloGameLogTypes.perimetr_shot_goal]: 'Гол с периметра',
    [WaterpoloGameLogTypes.perimetr_shot_on_goal]: 'Бросок с периметра в створ',
    [WaterpoloGameLogTypes.perimetr_shot_miss]: 'Бросок мимо с периметра',
    [WaterpoloGameLogTypes.perimetr_shot_blocked]: 'Заблокирован бросок с периметра',
    [WaterpoloGameLogTypes.perimetr_shot_save]: 'Отражен бросок с периметра',
    [WaterpoloGameLogTypes.post_shot_goal]: 'Гол со штанги',
    [WaterpoloGameLogTypes.post_shot_on_goal]: 'Бросок со штанги в створ',
    [WaterpoloGameLogTypes.post_shot_miss]: 'Бросок мимо со штанги',
    [WaterpoloGameLogTypes.post_shot_blocked]: 'Заблокирован бросок со штанги',
    [WaterpoloGameLogTypes.post_shot_save]: 'Отражен бросок со штанги',
    [WaterpoloGameLogTypes.fast_shot_goal]: 'Быстрый гол',
    [WaterpoloGameLogTypes.fast_shot_on_goal]: 'Быстрый бросок в створ',
    [WaterpoloGameLogTypes.fast_shot_miss]: 'Быстрый бросок мимо',
    [WaterpoloGameLogTypes.fast_shot_blocked]: 'Заблокирован быстрый бросок',
    [WaterpoloGameLogTypes.fast_shot_save]: 'Отражен быстрый бросок',
  },
  [Locales.en]: {
    [WaterpoloGameLogTypes.enter_game]: 'Entering the court',
    [WaterpoloGameLogTypes.exit_game]: 'Exit the court',
    [WaterpoloGameLogTypes.shot_miss]: 'Missing shoot',
    [WaterpoloGameLogTypes.counterattack_miss]: 'Throw past on the counterattack',
    [WaterpoloGameLogTypes.maneuver_miss]: 'Throw past from the manoeuvre',
    [WaterpoloGameLogTypes.center_forward_miss]: 'Throw past from center forward',
    [WaterpoloGameLogTypes.shot_on_goal]: 'Shot at the goal',
    [WaterpoloGameLogTypes.counterattack_on_goal]: 'Shot at the goal in a counterattack',
    [WaterpoloGameLogTypes.maneuver_on_goal]: 'Shot at the goal from a maneuver',
    [WaterpoloGameLogTypes.center_forward_on_goal]: 'Shot at the goal from center forward',
    [WaterpoloGameLogTypes.shot_blocked]: 'The throw is blocked',
    [WaterpoloGameLogTypes.counter_attack_shot_blocked]: 'A counterattack throw is blocked',
    [WaterpoloGameLogTypes.maneuver_shot_blocked]: 'The maneuver throw is blocked',
    [WaterpoloGameLogTypes.center_forward_shot_blocked]: 'The shot from the center forward is blocked',
    [WaterpoloGameLogTypes.goal]: 'Goal',
    [WaterpoloGameLogTypes.maneuver_goal]: 'Goal from a maneuver',
    [WaterpoloGameLogTypes.counterattack_goal]: 'Goal in a counterattack',
    [WaterpoloGameLogTypes.center_forward_goal]: 'Goal from the center forward',
    [WaterpoloGameLogTypes.shootout_attempt]: 'Penalty miss',
    [WaterpoloGameLogTypes.shootout_goal]: 'Penalty goal',
    [WaterpoloGameLogTypes.after_game_shootout_attempt]: 'Penalty miss',
    [WaterpoloGameLogTypes.after_game_shootout_goal]: 'Penalty goal',
    [WaterpoloGameLogTypes.assist]: 'Assist',
    [WaterpoloGameLogTypes.block_shot]: 'Blocking a throw',
    [WaterpoloGameLogTypes.minor_penalty]: 'Exclusion for 20 sec.',
    [WaterpoloGameLogTypes.major_penalty]: 'Exclusion with substitution 20 sec.',
    [WaterpoloGameLogTypes.match_penalty]: 'Exclusion with substitution after 4 min.',
    [WaterpoloGameLogTypes.foul]: 'Foul',
    [WaterpoloGameLogTypes.penalty_foul]: 'Penalty foul',
    [WaterpoloGameLogTypes.attack_foul]: 'Attack foul',
    [WaterpoloGameLogTypes.personal_foul]: 'Personal foul',
    [WaterpoloGameLogTypes.penalty_shot]: 'Penalty shot',
    [WaterpoloGameLogTypes.face_off_lose]: 'Losing in the sprint',
    [WaterpoloGameLogTypes.face_off_win]: 'Winning the sprint',
    [WaterpoloGameLogTypes.save]: 'Throw is reflected',
    [WaterpoloGameLogTypes.counterattack_save]: 'Throw in the counterattack is reflected',
    [WaterpoloGameLogTypes.maneuver_save]: 'Throw from a maneuver is reflected',
    [WaterpoloGameLogTypes.center_forward_save]: 'Throw from the center forward is reflected',
    [WaterpoloGameLogTypes.free_kick_save]: 'Free throw is reflected',
    [WaterpoloGameLogTypes.corner_save]: 'Shot from a corner is reflected',
    [WaterpoloGameLogTypes.shootout_save]: 'Penalty kick was deflected',
    [WaterpoloGameLogTypes.after_game_shootout_save]: 'Penalty kick was deflected',
    [WaterpoloGameLogTypes.timeout]: 'Timeout',
    [WaterpoloGameLogTypes.penalty_start]: 'The beginning of the penalty time',
    [WaterpoloGameLogTypes.penalty_end]: 'End of penalty time',
    [WaterpoloGameLogTypes.yellow_card]: 'Yellow card',
    [WaterpoloGameLogTypes.red_card]: 'Red card',
    [WaterpoloGameLogTypes.turnover]: 'Change of possession',
    [WaterpoloGameLogTypes.loss]: 'Loss',
    [WaterpoloGameLogTypes.steal]: 'Steal',
    [WaterpoloGameLogTypes.tackle]: 'Tackle',
    [WaterpoloGameLogTypes.free_kick_goal]: 'Free kick goal',
    [WaterpoloGameLogTypes.free_kick_on_goal]: 'Free kick shot on target',
    [WaterpoloGameLogTypes.free_kick_miss]: 'A throw by with a free kick',
    [WaterpoloGameLogTypes.free_kick_shot_blocked]: 'A free kick shot is blocked',
    [WaterpoloGameLogTypes.free_kick_pass]: 'Free kick pass',
    [WaterpoloGameLogTypes.free_kick_self]: 'Free kick draw',
    [WaterpoloGameLogTypes.corner_goal]: 'Corner goal',
    [WaterpoloGameLogTypes.corner_on_goal]: 'Shot from a corner into the target',
    [WaterpoloGameLogTypes.corner_miss]: 'Shot past from a corner',
    [WaterpoloGameLogTypes.corner_shot_blocked]: 'Blocked a shot from a corner',
    [WaterpoloGameLogTypes.corner_pass]: 'Pass from the corner',
    [WaterpoloGameLogTypes.corner_self]: 'Drawing a corner',
    [WaterpoloGameLogTypes.complete_penalty_time]: 'Early completion of the fine',

    [WaterpoloGameLogTypes.defense_select_position]: 'Defense: position selection',
    [WaterpoloGameLogTypes.save_possession]: 'Maintaining possession',
    [WaterpoloGameLogTypes.perimetr_shot_goal]: 'Goal from the perimeter',
    [WaterpoloGameLogTypes.perimetr_shot_on_goal]: 'Throw from perimeter on target',
    [WaterpoloGameLogTypes.perimetr_shot_miss]: 'Throw past from the perimeter',
    [WaterpoloGameLogTypes.perimetr_shot_blocked]: 'A throw from perimeter is blocked',
    [WaterpoloGameLogTypes.perimetr_shot_save]: 'A throw from perimeter is saved',
    [WaterpoloGameLogTypes.post_shot_goal]: 'Goal from the post',
    [WaterpoloGameLogTypes.post_shot_on_goal]: 'Throw from post on target',
    [WaterpoloGameLogTypes.post_shot_miss]: 'Throw past from the post',
    [WaterpoloGameLogTypes.post_shot_blocked]: 'A throw from post is blocked',
    [WaterpoloGameLogTypes.post_shot_save]: 'A throw from post is saved',
    [WaterpoloGameLogTypes.fast_shot_goal]: 'Fast goal',
    [WaterpoloGameLogTypes.fast_shot_on_goal]: 'Fast throw on target',
    [WaterpoloGameLogTypes.fast_shot_miss]: 'Fast throw is missed',
    [WaterpoloGameLogTypes.fast_shot_blocked]: 'Fast throw is blocked',
    [WaterpoloGameLogTypes.fast_shot_save]: 'Fast throw is saved',
  }
};
